import {
  Directive,
  Input,
  ElementRef,
  HostBinding,
} from '@angular/core';

@Directive({
  selector: '[bui-td]'
})
export class DataTdDirective {
  _el: HTMLElement;
  @Input()
  @HostBinding(`class.ant-table-selection-column`) checkbox: boolean;

  constructor(private _elementRef: ElementRef) {
    this._el = this._elementRef.nativeElement;
  }
}
